
export const isCustomLabelObject = (label) => {
  return typeof label === "object";
};
